import { baseRoutes } from '../../core/config/routes';

export const routes = {
  ...baseRoutes,
  admin: {
    ...baseRoutes.admin,
    demo: {
      form: 'admin/demo/form-submit',
      kanban: 'admin/demo/kanban',
    },
  },
  auth: {
    ...baseRoutes.auth,
  },
};
